import { Component, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { InstructionsModalComponent } from './instructions-modal/instructions-modal.component';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-instructions',
  templateUrl: './instructions.component.html',
  styleUrls: ['./instructions.component.scss']
})
export class InstructionsComponent implements OnInit {

  haveAddPermission:boolean=false;
  gridApi: GridApi;
  Statuslist: any = [];
  categoryList: any ;
  programdata: any;
  columnDefs;
  operations;
  rowData;
  tempoperation;
  advanceSearch;
  selectedRow;
  insForm: UntypedFormGroup;
  collapesedOrNot: boolean = false;
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal,
    private commonService: CommonService
  ) {

  }
  ngOnInit() {

    this.Statuslist = [
      { "value": "", "label": "All" },
      { "value": "1", "label": "Active" },
      { "value": "0", "label": "Inactive" }

  ];
  this.categoryList = [
    {"value": "", "label": "Select"},
    {"value": "USI", "label": "User Instruction"},
    {"value": "CS", "label": "Compliance Statement"}
  ]
this.programModuleState();
 
  //this.getModulesList();

  this.insForm = new UntypedFormGroup({
      NAME: new UntypedFormControl(""),
      MODULE_ID: new UntypedFormControl(""),
      ModuleStr: new UntypedFormControl(""),
      CATEGORY: new UntypedFormControl(""),
     // RECORD_STATE: new UntypedFormControl(""),
      RecordStatus: new UntypedFormControl(""),
  });

    this.collapesedOrNot = false;
    this.columnDefs =[
      { 
        "headerName": "User Instruction Names",
        "field": "NAME" 
      },
      { 
        "headerName": "Category",
        "field": "CATEGORY" 
      },
      { 
        "headerName": "Program", 
        "field": "ModuleStr" 
      },
      { 
        "headerName": "Status", 
        "field": "RecordStatus" 
      }
      
    ];

    this.tempoperation = [];
    //debugger;
    if (this.commonService.getScreenPermission("613", "N")) {
      this.haveAddPermission=true;

    }
    if (this.commonService.getScreenPermission("613", "E")) {
      this.tempoperation.push({
        "name": "Edit",
        "id": "edit"
      });
    }
    if (this.commonService.getScreenPermission("613", "V")) {
      this.tempoperation.push({
        "name": "View",
        "id": "View"
      });
    }
    if (this.commonService.getScreenPermission("613", "D")) {
      this.tempoperation.push({
        "name": "Delete",
        "id": "Delete"
      });
    }
    this.operations = this.tempoperation.map(operation => {

      return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
    this.setSummary("-1");
   

  }

  setSummary(text) {
    this.summaryService.getRecords("api/instruction/fetchinstructions/" + text).subscribe(summary => {
      this.rowData = summary;
    });
  }

  programModuleState() {
    this.summaryService.GetData("api/common/getapptypemodules").subscribe((res) => {
      this.programdata = res;
    })
  }
  setSearch() {
    this.SearchClear();

    this.setSummary("-1");
  }

  SearchClear() {
    this.insForm.patchValue({
      NAME: "",
      RecordStatus: "",
      CATEGORY: "",
      MODULE_ID: ""
    });
  }

  AdvanceSearch() {
    var formData = this.insForm.value;
    this.getSearchData(formData);
  }

  getSearchData(searchData) {debugger;
    this.summaryService.AdvanceSearch('api/instruction/search', searchData).subscribe(summary => {debugger;
      this.rowData = summary
    });
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(RecordData: any) {

    const modelRef = this['self'].modalService.open(InstructionsModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modelRef.componentInstance.Content = {
      heading: 'Edit User',
      content: { id: RecordData.data['ID'], InstructionType: RecordData.data['CATEGORY'] }
    }
  }

  edit(RecordData: any) {

    const modalRef = this['self'].modalService.open(InstructionsModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true,

    });
    modalRef.componentInstance.Content = {
      heading: 'Edit',
      content: { id: RecordData['ID'], InstructionType: RecordData['CategoryCode']  }
    }
    modalRef.result.then(result => {
      this['self'].setSummary();
    })
  }


  add(type: any) {

    const modalRef = this.modalService.open(InstructionsModalComponent, {

      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true,

    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: { id: "", InstructionType: type }
    }
    modalRef.result.then(result => {
      this.setSummary("-1");
    })
  }

  View(RecordData: any) {
   
    const modelRef=this['self'].modalService.open(InstructionsModalComponent, {
     backdrop: false,
     keyboard: false,
     windowClass: 'modal-lg right modal-right',
     animation: true
   });
   modelRef.componentInstance.Content={
     heading: 'View',
     content: { id: RecordData['ID'], InstructionType: RecordData['CategoryCode'] }
   }
 }

 Delete(RecordData: any) {
  let id = RecordData['ID'];
  let name = RecordData['NAME'];
  let message = "";
  let validationmessage="";
  if(RecordData["CategoryCode"]=="USI")
  {
    validationmessage='Are you sure you want to delete the User instruction ' +"'" + name + "'" + ' ?'
  }
  else{
     validationmessage='Are you sure you want to delete the Compliance statement ' +"'" + name + "'" + ' ?'
  }
  const modalRef = this['self'].modalService.open(DeleteBoxComponent, {backdrop: false});
  modalRef.componentInstance.Content={ heading: 'Delete', 
  custommessage: validationmessage,
   ProceedButtonName: "Delete", 
   TerminateButtonName: "Cancel" }
  modalRef.result.then(result => {
    if (result == "okclick")
      this["self"].summaryService.Delete('api/instruction/delete?id=' + id).subscribe(summary => {
        if (summary["Status"] == 0) {
          this['self'].commonService.SuccessBanner(summary.Message);
          this['self'].setSummary();
        }
        else {
          this["self"].commonService.ValidationBanner(summary.Message);
        }

     });

  })

};
}
